var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#DE2910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 3.1L4.64 4.47H6.08L4.91 5.31L5.36 6.68L4.2 5.84L3.04 6.68L3.49 5.31L2.32 4.47H3.76L4.2 3.1Z",
    fill: "#FFDE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26 2.73L7.41 3.2L7.9 3.18L7.5 3.47L7.67 3.94L7.26 3.65L6.87 3.95L7.01 3.47L6.61 3.2L7.11 3.2L7.26 2.73Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 4.11L8.53 4.58L9.02 4.56L8.62 4.85L8.79 5.32L8.38 5.03L7.99 5.33L8.13 4.85L7.73 4.58L8.23 4.58L8.38 4.11Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34 6.03L8.49 6.5L8.98 6.48L8.58 6.77L8.75 7.24L8.34 6.95L7.95 7.25L8.09 6.77L7.69 6.5L8.19 6.5L8.34 6.03Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 7.36L7.35 7.83L7.84 7.81L7.44 8.1L7.61 8.57L7.2 8.28L6.81 8.58L6.95 8.1L6.55 7.83L7.05 7.83L7.2 7.36Z",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnIcon);
export default __webpack_public_path__ + "static/media/cn-icon.66a04da71cf93b70f0c7b92149bb6048.svg";
export { ForwardRef as ReactComponent };